import { css } from '@emotion/core'
import theme from 'Theme'
const {
  mixins,
  components: { productCard }
} = theme

export const plain = () => {
  return css`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border: 2px solid gainsboro;
    background-color: white;

    .image-link {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 130%;
      position: relative;
    }

    .img-wrapper {
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
    }

    img {
      max-height: 100%;
      flex-shrink: 0;
      object-fit: contain;
    }

    .footer {
      min-height: 130px;
      display: block;
      padding: 8px;
      > * {
        margin-bottom: 8px;
      }
      > .price {
        margin-bottom: 0;
      }
      h5 {
        font-weight: normal;
        line-height: 1.2;
        margin-bottom: 5px;
      }
    }

    .brand {
      ${mixins.brandTypography(theme)}
      line-height: 1.2;
    }

    .discount {
      text-decoration: line-through;
      color: ${productCard.discountColor};
    }

    .price {
      font-weight: bold;
    }

    &:hover {
      cursor: pointer;
      .footer {
        text-decoration: underline;
      }
    }
  `
}

export default plain
